import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import { PaginationLimit, tenantRelationshipOptions } from "../../Config";
import Tooltip from "../Tooltip";
import { MdDelete, MdModeEditOutline } from "react-icons/md";
import { IoCopySharp } from "react-icons/io5";
import { capitalizeFirstLetter, handleCopy } from "../../helpers";

// const genderMap = {
//   1: "Male",
//   2: "Female",
// };

const Table = ({ apiData , setSelectedData, setCoOccupantEdit, setIsDeleteCoOccupant }) => {
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  const handleEdit = (item) => {
    setSelectedData(item);
    setCoOccupantEdit(true);
  };

  const handleDelete = (item) => {
    setSelectedData(item);
    setIsDeleteCoOccupant(true);
  }
 
  const ActionBtns = (item) => (
    <div className="flex items-center gap-3">
      <Tooltip label="Click to edit the co-occupant">
        <button
          onClick={() => handleEdit(item)}
          className="text-gray-400 hover:text-gray-700 transition bg-gray-50 rounded-full p-1.5"
        >
          <MdModeEditOutline size={16} />
        </button>
      </Tooltip>
      <Tooltip label="Click to delete the co-occupant">
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleDelete(item);
          }}
          className="text-gray-400 hover:text-rose-600 transition bg-gray-50 rounded-full p-1.5"
        >
          <MdDelete size={16} />
        </button>
      </Tooltip>
    </div>
  );

  useEffect(() => {
    if (apiData) {
      const tempData = apiData.map((item) => ({
        name: getName(item),
        // gender: getGender(item),
        mobile: getMobile(item),
        relationship: getRelationship(item),
        action: ActionBtns(item),
      }));
      setData(tempData);
    }
  }, [apiData, openActionMenu]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // const getName = (item) => (
  //   <div className="flex flex-col leading-tight">
  //     <span className="text-gray-800 text-sm font-medium">
  //       {capitalizeFirstLetter(item?.name || "")}
  //     </span>
  //   </div>
  // );

const getName = (item) => {
    const name = capitalizeFirstLetter(item?.name || "N/A");

    return (
      <UserImageWrapper
      >
        <UserImage src={Images.Avatar} alt={name} />

        <div className="flex flex-col min-w-0">
          <span className="text-sm font-medium text-gray-900 truncate max-w-[180px]">
            {name}
          </span>

          {/* <div className="flex items-center gap-1 text-xs text-gray-400">
            <span>#{item.mobile}</span>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleCopy(item.mobile);
              }}
              className="hover:text-gray-600 transition"
              title="Copy number"
            >
              <IoCopySharp size={12} />
            </button>
          </div> */}
        </div>
      </UserImageWrapper>
    );
  };


  // const getGender = (item) => (
  //   <span
  //     className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold ${
  //       item.gender === 1
  //         ? "bg-blue-50 text-blue-700"
  //         : "bg-pink-50 text-pink-700"
  //     }`}
  //   >
  //     {genderMap[item.gender] || "--"}
  //   </span>
  // );
 const getMobile = (item) => (
  <div className="flex items-center gap-2">
    <span className="text-sm font-medium tracking-wide text-slate-700">
      {item.mobile}
    </span>

    <button
      onClick={(e) => {
        e.stopPropagation();
        handleCopy(item.mobile);
      }}
      className="text-slate-400 hover:text-gray-600 transition"
      title="Copy"
    >
      <IoCopySharp size={12} />
    </button>
  </div>
);

  const getRelationship = (item) => {
    const relationship = tenantRelationshipOptions.find(
        (option) => option.value === item.relationship
    );

    return (
        <span className="inline-flex items-center rounded-full bg-slate-100 px-3 py-1 text-xs font-medium text-slate-700">
        {relationship?.label || "--"}
        </span>
    );
  };


  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        {
          Header: "Name",
          accessor: "name",
        },

        {
          Header: "Mobile",
          accessor: "mobile",
        },
      ];
    }
    return [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Mobile",
        accessor: "mobile",
      },
      {
        Header: "Relationship",
        accessor: "relationship",
      },
      {
        Header: "Action",
        accessor: "action",
      }
    ];
  }, [isMobileView]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex, pageSize },
    previousPage,
    nextPage,
    setPageSize,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination,
  );

  // useEffect(() => {
  //   setPageSize(PaginationLimit);
  // }, []);

  useEffect(() => {
    setCurrentPage(pageIndex); // Update current page on state change
  }, [pageIndex]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${
                          column.isSortedDesc ? "-rotate-90" : "rotate-90"
                        } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody
          {...getTableBodyProps()}
          hasdata={(apiData?.length > 0).toString()}
        >
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr
                  {...row.getRowProps({ style: { height: "80px" } })}
                  hasdata={(apiData?.length > 0).toString()}
                >
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        style={
                          cell.column.width ? { width: cell.column.width } : {}
                        }
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>Activity:</strong>{" "}
                          {data[rowIndex].description}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};
// const ActionBtnWrapper = tw.div`grid xl:grid-cols-2 md:grid-cols-1 grid-cols-4 w-40 mb-1 gap-y-1 gap-x-1.5 md:w-16 mt-3 md:mt-0`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
  props.hasdata === "true"
    ? "border-b"
    : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const UserImageWrapper = tw.div` flex items-center gap-2 cursor-pointer`;
const UserImage = tw.img`w-10 h-10 rounded-full `;

export default Table;
